import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import {
  getAllJobsTrackerListAction,
  getAllJobProgressCommentsAction,
  addJobProgressCommentAction,
  getAllOpenJobsListAction,
  addDocumentLinkAction,
  getDocumentsLinkAction,
  getAllAssignedClientsOpenJobsAction,
  getAllOpenItemsAction,
  getFileAndFolderAction,
  getAdvanceInvoiceCountAction,
  getDailyActiveUserReportAction,
  getUserSessionLoginCountReportAction,
  getMonthlyActiveUserReportAction,
  getUserReportAction,
  getUserWiseInvoiceCountReportAction,
  getAllEInvoiceEWayBillListAction,
  getAllClientLockDateAction,
  getAllExternalUserEmailerAction,
  getMonthlyInvoiceCountGraphAction,
  getAllUserApprovedEntryAction,
  getAllClientBulkUploadReportAction,
  getUserWiseOCRReportAction,
  getClientWiseOCRReportAction,
} from "./actions";
import { ListingType } from "./listingTypes";
import { listingReducer } from "./reducer";

export const listingSlice = createSlice({
  name: "listing",
  initialState,
  reducers: listingReducer,
  extraReducers: {
    [getAllJobsTrackerListAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      fetching: true,
    }),
    [getAllJobsTrackerListAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        jobTrackerListing: result?.data,
      };
    },
    [getAllJobsTrackerListAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addJobProgressCommentAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      jobProgressCommentsFetching: true,
    }),
    [addJobProgressCommentAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          jobProgressCommentsFetching: false,
          jobProgressCommentsSuccess: success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        jobProgressCommentsFetching: false,
        jobProgressCommentsSuccess: success,
        statusCode: status_code,
      };
    },
    [addJobProgressCommentAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      jobProgressCommentsFetching: false,
      jobProgressCommentsSuccess: 0,
      error: error?.message,
    }),
    [getAllJobProgressCommentsAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      jobProgressCommentsFetching: true,
    }),
    [getAllJobProgressCommentsAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          jobProgressCommentsFetching: false,
          jobProgressCommentsSuccess: success,
          error: message,
        };
      }

      return {
        ...state,
        jobProgressCommentsFetching: false,
        jobProgressCommentsList: result,
        statusCode: status_code,
      };
    },
    [getAllJobProgressCommentsAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      jobProgressCommentsFetching: false,
      jobProgressCommentsSuccess: 0,
      error: error?.message,
    }),
    [getAllOpenJobsListAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      fetching: true,
    }),
    [getAllOpenJobsListAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          jobProgressCommentsSuccess: success,
        };
      }

      return {
        ...state,
        fetching: false,
        openJobsListing: result,
        openJobsListingTotalCount: total_count,
      };
    },
    [getAllOpenJobsListAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addDocumentLinkAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      jobProgressCommentsFetching: true,
    }),
    [addDocumentLinkAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          jobProgressCommentsFetching: false,
          jobProgressCommentsSuccess: success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        jobProgressCommentsFetching: false,
        jobProgressCommentsSuccess: success,
        statusCode: status_code,
      };
    },
    [addDocumentLinkAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      jobProgressCommentsFetching: false,
      jobProgressCommentsSuccess: 0,
      error: error?.message,
    }),
    [getDocumentsLinkAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      jobProgressCommentsFetching: true,
    }),
    [getDocumentsLinkAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { status_code, result, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          jobProgressCommentsFetching: false,
          jobProgressCommentsSuccess: success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        jobProgressCommentsFetching: false,
        statusCode: status_code,
        documentsLinkList: result,
      };
    },
    [getDocumentsLinkAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      jobProgressCommentsFetching: false,
      jobProgressCommentsSuccess: 0,
    }),
    [getAllAssignedClientsOpenJobsAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllAssignedClientsOpenJobsAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          jobProgressCommentsSuccess: success,
        };
      }

      return {
        ...state,
        fetching: false,
        assignedClientsOpenJobsList: result,
      };
    },
    [getAllAssignedClientsOpenJobsAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllOpenItemsAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      fetching: true,
    }),
    [getAllOpenItemsAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, data, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        allOpenItemsList: data?.data,
        statusCode: status_code,
      };
    },
    [getAllOpenItemsAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getFileAndFolderAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      fetching: true,
    }),
    [getFileAndFolderAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, file_folder_res, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        fileFolderCount: file_folder_res,
      };
    },
    [getFileAndFolderAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),
    [getAdvanceInvoiceCountAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAdvanceInvoiceCountAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        invoiceCount: result.data,
      };
    },
    [getAdvanceInvoiceCountAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getDailyActiveUserReportAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getDailyActiveUserReportAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        dailyActiveUserList: result,
      };
    },
    [getDailyActiveUserReportAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getUserSessionLoginCountReportAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getUserSessionLoginCountReportAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        userSessionLoginCountList: result,
      };
    },
    [getUserSessionLoginCountReportAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getMonthlyActiveUserReportAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMonthlyActiveUserReportAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        monthlyActiveUserList: result,
      };
    },
    [getMonthlyActiveUserReportAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getUserReportAction.pending.toString()]: (state: ListingType) => ({
      ...state,
      fetching: true,
    }),
    [getUserReportAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        userReportList: result,
      };
    },
    [getUserReportAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getUserWiseInvoiceCountReportAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getUserWiseInvoiceCountReportAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        userWiseInvoiceCountReportList: result,
      };
    },
    [getUserWiseInvoiceCountReportAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),
    [getAllEInvoiceEWayBillListAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllEInvoiceEWayBillListAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allEwayBillEInvoiceList: result,
      };
    },

    [getAllClientLockDateAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllClientLockDateAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        allClientLockDateList: result?.data,
        allClientLockDateTotalCount:result?.total_count
      };
    },
    [getAllClientLockDateAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),


    // 
    [getAllExternalUserEmailerAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllExternalUserEmailerAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, result, status_code ,total_count} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        allExternalUserEmailerList: result,
        allExternalUserEmailerTotalCount:total_count
      };
    },
    [getAllExternalUserEmailerAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),

    [getMonthlyInvoiceCountGraphAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMonthlyInvoiceCountGraphAction.fulfilled.toString()]: (
      state: ListingType,
      {payload}
    ) => {
      const {success, message, result, status_code} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return{
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        invoiceCountGraphData: result?.data
      };
    },
    [getMonthlyInvoiceCountGraphAction.rejected.toString()]
    : (
      state: ListingType,
      {error}
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),


    
    [getAllUserApprovedEntryAction.pending.toString()]: (
      state: ListingType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllUserApprovedEntryAction.fulfilled.toString()]: (
      state: ListingType,
      { payload }
    ) => {
      const { success, message, data, status_code ,total_count} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        allUserApprovedEntryList: data,
        allUserApprovedEntryTotalCount:total_count
      };
    },
    [getAllUserApprovedEntryAction.rejected.toString()]: (
      state: ListingType,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),
// deewnk
  [getAllClientBulkUploadReportAction.pending.toString()]: (
  state: ListingType
) => ({
  ...state,
  fetching: true,
}),
[getAllClientBulkUploadReportAction.fulfilled.toString()]: (
  state: ListingType,
  { payload }
) => {
  const { success, message, result, status_code ,total_count} = payload;
  if (success === 0) {
    return {
      ...state,
      fetching: false,
      error: message,
      statusCode: status_code,
      success,
    };
  }

  return {
    ...state,
    fetching: false,
    success,
    statusCode: status_code,
    allClientBulkUploadList: result?.data,
    allClientBulkUploadTotalCount:result?.total_count
  };
},
[getAllClientBulkUploadReportAction.rejected.toString()]: (
  state: ListingType,
  { error }
) => ({
  ...state,
  error: error?.message,
  fetching: false,
}),
[getUserWiseOCRReportAction.pending.toString()]: (
  state: ListingType
) => ({
  ...state,
  fetching: true,
}),
[getUserWiseOCRReportAction.fulfilled.toString()]: (
  state: ListingType,
  { payload }
) => {
  const { success, message, result, status_code ,total_count} = payload;
  if (success === 0) {
    return {
      ...state,
      fetching: false,
      error: message,
      statusCode: status_code,
      success,
    };
  }

  return {
    ...state,
    fetching: false,
    success,
    statusCode: status_code,
    userWiseOCRReportList: result,
  };
},
[getUserWiseOCRReportAction.rejected.toString()]: (
  state: ListingType,
  { error }
) => ({
  ...state,
  error: error?.message,
  fetching: false,
}),
[getClientWiseOCRReportAction.pending.toString()]: (
  state: ListingType
) => ({
  ...state,
  fetching: true,
}),
[getClientWiseOCRReportAction.fulfilled.toString()]: (
  state: ListingType,
  { payload }
) => {
  const { success, message, result, status_code ,total_count} = payload;
  if (success === 0) {
    return {
      ...state,
      fetching: false,
      error: message,
      statusCode: status_code,
      success,
    };
  }

  return {
    ...state,
    fetching: false,
    success,
    statusCode: status_code,
    clientWiseOCRReportList: result?.data,
    clientWiseOCRReportTotalData:result?.total_count
  };
},
[getClientWiseOCRReportAction.rejected.toString()]: (
  state: ListingType,
  { error }
) => ({
  ...state,
  error: error?.message,
  fetching: false,
}),

  },
});

export const {
  resetError: resetListingError,
  resetSuccess: resetListingSuccess,
  resetJobProgressCommentsListing,
  resetJobProgressCommentsSuccess,
  resetListingFetching,
  resetJobTrackerListing,
  resetOpenJobsList,
  resetDocumentsLinkList,
  resetAssginedClientsOpenJobsList,
  resetAllOpenItemsLst,
  resetFileFolderCountData,
  resetInvoiveCountData,
  resetAllOpenItemsListTotelCount,
  resetDailyActiveUserList,
  resetUserSessionLoginCountList,
  resetMonthlyActiveUserList,
  resetUserReportList,
  resetUserWiseInvoiceCountReportList,
  resetAllEwayBillEInvoiceList,
  resetAllClientLockDateList,
  resetAllClientLockDateTotalCount,
  resetAllExternalUserEmailerList,
  resetAllExternalUserEmailerTotalCount,
  resetInvoiceMonthlyGraphData,
  resetAlluserApprovedEntryList,
  resetAlluserApprovedEntryTotalCount,
  resetAllClientBulkUploadList,
  resetAllClientBulkUploadTotalCount,
  resetUserWiseOCRReportList,
  resetClientWiseOCRReportList
} = listingSlice.actions;
